<app-main-nav-bar></app-main-nav-bar>
<!--page-->
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-heading-mobile"></div>
      <div class="card-body">
        <h4 class="title">بیمه تجهیزات الکترونیک</h4>
        <br>
        <p>
          یافتن بیمه موبایل مطمئن کاری است که ما
          <br>
          به بهترین نحو برای شما انجام میدهیم.
        </p>
        <br>
        <br>
        <br>
        <br>
        <div class="col-12">
          <div class="col-md-6 col-xs-6">
            <a routerLink="/mobile/basic-information">
              <button type="button" class="btn btn-primary pull-left">خرید بیمه</button>
            </a>
          </div>
          <div class="col-md-6 col-xs-6">
            <a routerLink="/MOBILE/requests">
              <button type="button" class="btn btn-primary pull-right" style="background-color: darkorange">بیمه های من
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
